<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs pos-relative" style="min-height: 23em;">
    <app-loader [showLoader]=showLoad></app-loader>
    <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom pos-relative">
        <div class="o-stack__cell">
            <h5>{{sectiontitle}}</h5>
        </div>
        <a href="#" class="datatable_download_icon" *ngIf="downloadConfiguration && downloadConfiguration.enableDownload && hasData"
            (click)="downloadDataInCSV($event)" target="_blank"><i class="fa fa-download" aria-hidden="true"></i></a>
    </div>
    <div class="analytics-portlet-content">

        <div style="width: 100%; height: 100%;">

            <div id="chart"></div>

        </div>
        <div class="no-data-container" *ngIf="!hasData">
            <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom pos-relative">
                <div class="o-stack__cell">
                    <h5>{{sectiontitle}}</h5>
                </div>
            </div>
            <div class="map-no-data">No Data to Display</div>
        </div>
    </div>
</div>
